class Carousel {

	constructor() {
		this.init();
	}

	init() {

		// Add slider here
	}
}

export default Carousel;
